export default {
  container:{
    textAlign: 'left',
    borderRadius: '5px',
    height: '650px',
    overflowY: 'visible'
  },
  process:{
    position: 'relative',
    height: '41px',
    margin: '0px 0 40px 20px',
    width: '234px'
  },
  processor:{
    margin: '0 -40px',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  processorItem:{
    width: '100%', textAlign: 'center', position: 'relative'
  },
  processBar:{
    width: '31px',
    height: '31px',
    margin: '0 20px 5px',
    display: 'inline-block',
    background: '#FFF',
    borderRadius: '50%',
    border: '5px solid #cccccc',
    position: 'relative',
    cursor: 'pointer',
    zIndex: 1,
    '&:before': {
      content: '',
      width: '15px',
      height: '7px',
      borderBottom: 'solid 4.3px #ffffff',
      borderLeft: 'solid 4.3px #ffffff',
      display: 'inline-block',
      position: 'absolute',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      transform: 'rotate(-45deg)',
      margin: 'auto'
    },
    '&.active': { borderColor: '#393060' },
    '&.pre-fill': { borderColor: '#76c520' },
    '&.success': { background: '#76c520', borderColor: '#76c520' }
  },
  processLine:{
    width: '100%',
    height: '7px',
    background: '#d8d8d8',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '50%',
    margin: 'auto 0 auto 20px',
    '&.active': { background: '#887fff' },
    '&.pre-fill': { background: '#d8d8d8' },
    '&.success': { background: '#76c520' }
  },
  processStatus:{
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '12px',
    fontWeight: 600,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
    textAlign: 'center',
    display: 'flex',
    '&.active': { color: '#393060' },
    '&.pre-fill': {},
    '&.success': { color: '#76c520' }
  },
  row:{
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '10px'
  },
  actions: {
    minWidth: 150,
    margin: '0 0 0 10px'
  },
  Input: {
    width: 450,
    maxWidth: '100%'
  },
  Field: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 0,
    textAlign: 'center'
  },
  searchBox: {
    margin: '10px 0 10px 0'
  },
  subTitle:{
    fontFamily: 'AvenirNext-DemiBold',
    fontSize: '14px',
    fontWeight: 600,
    color: '#96979a',
    marginBottom: '5px'
  },
  controlSelect:{ marginTop: '20px', marginBottom: '20px' }

}
